<div class="modal-header">
  <h5 class="modal-title">New profile</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div>
    <select ngbAutofocus
            [(ngModel)]="selectedProfile"
            class="form-select">
      <option [ngValue]="'wifi'">Wi-Fi Profile</option>
      <option [ngValue]="'notifications'">Notifications Profile</option>
      <option [ngValue]="'restrictions'">Restrictions Profile</option>
    </select>
  </div>
  <div class="p-2">
    @switch (selectedProfile) {
      @case ('wifi') {
        <ml-mdm-apple-create-wifi-profile [udid]="udid$ | async"></ml-mdm-apple-create-wifi-profile>
      }
      @case ('notifications') {
        <ml-mdm-apple-create-notifications-profile [udid]="udid$ | async">
        </ml-mdm-apple-create-notifications-profile>
      }
      @case ('restrictions') {
        <ml-mdm-apple-create-restrictions-profile [udid]="udid$ | async">
        </ml-mdm-apple-create-restrictions-profile>
      }
    }
  </div>
</div>